import { PHONE_REGEX_PATTERN, START_WITH_SPACE } from '@app/constant/RegexConstant'
import { Translation } from 'react-i18next'
import * as Yup from 'yup'

const MerchantCreateSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .max(255)
    .trim()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>)
    .matches(START_WITH_SPACE, {
      message: <Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>,
    }),
  email: Yup.string()
    .email(<Translation>{(t) => t('VALIDATE.VALID_EMAIL')}</Translation>)
    .max(255)
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_EMAIL')}</Translation>),
  phone: Yup.string()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_PHONE')}</Translation>)
    .matches(PHONE_REGEX_PATTERN, {
      message: <Translation>{(t) => t('VALIDATE.VALID_PHONE')}</Translation>,
    }),
  address: Yup.string()
    .max(255)
    .trim()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_ADDRESS')}</Translation>),
  logo: Yup.array()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_FILE')}</Translation>)
    .min(1, <Translation>{(t) => t('VALIDATE.MIN_FILE', { number: '1' })}</Translation>)
    .max(1, <Translation>{(t) => t('VALIDATE.MAX_FILE', { number: '1' })}</Translation>),
  categories: Yup.array()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_CATEGORY')}</Translation>)
    .min(1, <Translation>{(t) => t('VALIDATE.MIN_CATEGORY', { number: '1' })}</Translation>),
  pos: Yup.array()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_POS')}</Translation>)
    .min(1, <Translation>{(t) => t('VALIDATE.VALID_POS', { number: '1' })}</Translation>),
})

export default MerchantCreateSchema
